import { render, staticRenderFns } from "./comprehenOperateScreenFrame.vue?vue&type=template&id=5e0a9b92&scoped=true&"
import script from "./comprehenOperateScreenFrame.vue?vue&type=script&lang=js&"
export * from "./comprehenOperateScreenFrame.vue?vue&type=script&lang=js&"
import style0 from "./comprehenOperateScreenFrame.vue?vue&type=style&index=0&id=5e0a9b92&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0a9b92",
  null
  
)

component.options.__file = "comprehenOperateScreenFrame.vue"
export default component.exports